import { MyMonitoringPage } from '@apps-common/apps/portal/pages/my-monitoring/Index'

export const MyMonitoring = () => <MyMonitoringPage />
